<!--
 - Viewer component
 -
 - @version
 - 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 - 4.62.0 OAUI-654 Remove calls to getOrderCrudApiRouting
 - 4.61.0 PRDS-176 Integrate digital spools into order-admin-ui
 - 4.56.0 OAUI-596 Migrate Large Model Viewer into Angular
 - 4.56.0 OAUI-614 Migrate LMV navigation bar into angular
 -
 - @author Jenny Lam <jlam@buildcentrix.com>
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 -
 - @copyright (c) 2023 Build Centrix
 -->
<div class="row">
  <div class="col-12">
    <app-viewer-header-component
      [showHeader]="true"
      [title]="title"
      [subtitle]="subtitle"
      [orderIndex]="orderIndex"
    >
    </app-viewer-header-component>
  </div>
</div>
<div>
  <bc-atoms-loader
    [title]="('modelViewer.loading.title'|translate)"
    [active]="viewerLoading"
    [fullscreen]="false"
  ></bc-atoms-loader>
  <bc-organisms-forge-viewer
    *ngIf="!viewerLoading"
    [assemblyModel]="assemblyModel"
    [viewerLoading]="viewerLoading"
    [screenHeight]="screenHeight"
    [screenWidth]="screenWidth"
    [accessToken]="accessToken"
    [dataUrn]="dataUrn"
    [statusesData]="statusesMappingsData"
    [modelItemStatusesData]="modelItemStatusesData"
    [bcxExtensions]="bcxExtensions"
    (viewerDataEmitted)="handleItemLoaded($event)"
    (changeItemStatusEmitted)="handleChangeItemStatus($event)"
  >
  </bc-organisms-forge-viewer>
</div>
